import { ICategoryModel } from "../models/category.model";
import { DocTypeModel } from "../models/docType.model";
import { LangCode } from "../models/language.model";
import { IPriority } from "../models/priorities.model";
import { IRecordAccessClassificationModel } from "../models/recordAccessClassification.model";
import ServiceBase from "./base.service";

export class GlobalDataService extends ServiceBase {
  priorities = async (): Promise<IPriority[]> => this.get<IPriority[]>("global-data/priorities");

  topics = async (): Promise<string[]> => this.get<string[]>("global-data/topics");

  languages = async (): Promise<LangCode[]> => this.get<LangCode[]>("global-data/languages");

  departments = async (): Promise<string[]> => this.get<string[]>("global-data/departments");

  divisions = async (): Promise<string[]> => this.get<string[]>("global-data/divisions");

  docTypes = async (): Promise<DocTypeModel[]> => this.get<DocTypeModel[]>("global-data/doctypes");

  countries = async (): Promise<string[]> => this.get<string[]>("global-data/countries");

  sectors = async (): Promise<string[]> => this.get<string[]>("global-data/sectors");

  categories = async (): Promise<ICategoryModel[]> => this.get<ICategoryModel[]>("global-data/categories");

  recordAccessClassifications = async (): Promise<IRecordAccessClassificationModel[]> =>
    this.get<IRecordAccessClassificationModel[]>("global-data/record-access-classifications");
}

const globalDataService = new GlobalDataService();

export default globalDataService;
